import { render, staticRenderFns } from "./CategoriesClientButton.vue?vue&type=template&id=44a9f276&"
import script from "./CategoriesClientButton.vue?vue&type=script&lang=js&"
export * from "./CategoriesClientButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports